import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Image, useDeviceType } from '@cian/ui-kit';

import { MainNews } from '../../components/MainNews';
import { selectMainNews } from '../../selectors/mainNews';
import { selectTopMainArticle } from '../../selectors/mainArticles';
import { IMainArticleDetailed, MainArticleDetailed, MainArticleSimplified } from '../../components/MainArticle';
import { TThunkDispatch } from '../../types/redux';
import { getMainNews } from '../../actions/mainNews';
import { ERequestStatus } from '../../types/requestStatus';
import { NotFound } from '../../components/NotFound';
import * as s from './MainArticleAndMainNewsContainer.css';

/** Главная статья и блок новостей на Главной */
export const MainArticleAndMainNewsContainer = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const { search } = useLocation();
  const [withTag, setWithTag] = useState(new URLSearchParams(search).get('with-tag') || '');
  const history = useHistory();
  const deviceType = useDeviceType();
  const isPhone = () => deviceType === 'phone';
  const mainNews = useSelector(selectMainNews);
  const mainArticle = useSelector(selectTopMainArticle);

  /**
   * Запрашиваем список новостей, если еще ни разу не запрашивали (1)
   * или сменился with-tag в qs (2)
   */
  useEffect(() => {
    const qsWithTag = new URLSearchParams(search).get('with-tag') || '';

    if (qsWithTag !== withTag || mainNews.status === ERequestStatus.Initial) {
      dispatch(getMainNews({ limit: 5, tag: qsWithTag })).finally();
    }

    if (qsWithTag !== withTag) {
      setWithTag(qsWithTag);
    }
  }, [dispatch, mainNews.status, search, withTag]);

  /** Роутит по клику по рубрике */
  const handleRubricButtonClick: IMainArticleDetailed['onRubricButtonClick'] = (e, url) => {
    e.stopPropagation();
    history.push(url);
  };

  /** Роутит по клику по статье */
  const handleArticleClick = (url: string) => {
    history.push(url);
  };

  if (!mainArticle && !mainNews?.items?.length) {
    return <NotFound />;
  }

  return (
    <div className={`${s['wrapper']}`}>
      <div className={`${s['main-article-wrapper']}`}>
        {mainArticle &&
          (isPhone() ? (
            <MainArticleSimplified
              title={mainArticle.attributes.title}
              image={mainArticle.attributes.image}
              onClick={() => handleArticleClick(`/stati-${mainArticle.attributes.slug}-${mainArticle.id}/`)}
            />
          ) : (
            <MainArticleDetailed
              title={mainArticle.attributes.title}
              image={mainArticle.attributes.image}
              rubric={mainArticle.attributes.rubrics?.length ? mainArticle.attributes.rubrics[0] : undefined}
              viewsCount={mainArticle.attributes.numViews}
              commentsCount={mainArticle.attributes.commentsCount}
              onClick={() => handleArticleClick(`/stati-${mainArticle.attributes.slug}-${mainArticle.id}/`)}
              onRubricButtonClick={handleRubricButtonClick}
            />
          ))}

        {/* Прелоадер */}
        {!mainArticle && <Image borderRadius={0} src={''} theme="light" />}
      </div>

      <MainNews items={mainNews.items} />
    </div>
  );
};
